import { useState } from "react";
import { ghostBtnClass } from "./logisticsRoutesShared";
import { lookupLogisticsSerialStatus } from "@/lib/logistics/serialStatusClient";

export function LogisticsSerialStatusPrompt() {
  const [serial, setSerial] = useState("");
  const [label, setLabel] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run(ask: boolean) {
    setBusy(true);
    setError(null);
    const res = await lookupLogisticsSerialStatus(serial, ask);
    setBusy(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    setLabel(ask ? `${res.data.label} Asked QC (${res.data.sent} sent).` : res.data.label);
  }

  return (
    <section className="space-y-2 rounded-2xl border border-gray-200 p-4 dark:border-zinc-700">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-zinc-100">Ask about a serial</h3>
      <p className="text-xs text-gray-500 dark:text-zinc-400">
        Looks up where that building is in production and QC. Ask QC emails the people set to receive failure notices.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <input
          className="min-w-48 flex-1 rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm dark:border-zinc-600 dark:bg-zinc-900"
          value={serial}
          placeholder="Serial"
          aria-label="Serial to ask about"
          onChange={(event) => setSerial(event.target.value)}
        />
        <button type="button" className={ghostBtnClass} disabled={busy || !serial.trim()} onClick={() => void run(false)}>
          Check status
        </button>
        <button type="button" className={ghostBtnClass} disabled={busy || !serial.trim()} onClick={() => void run(true)}>
          Ask QC
        </button>
      </div>
      {label ? <p className="text-sm text-gray-800 dark:text-zinc-100">{label}</p> : null}
      {error ? <p className="text-sm text-red-700 dark:text-red-300">{error}</p> : null}
    </section>
  );
}
